<template>
  <div class="form">
    <BaseLockup class="lockup"/>
    <form @submit.prevent="submit()">
      <BaseText6 class="subcopy" text="We just need one more detail before<br>you step into the octagon"/>
      <div class="input-container">
        <BaseInput
          :value="email"
          type="email"
          placeholder="Email address"
          @input="email = $event"
          :required="true"
        />
        <BaseText6 class="error-message" v-if="errorMessage" :text="errorMessage"/>
      </div>
      <button class="submit-button" type="submit">
        <BaseButtonOctagon text="Let's<br>do it"/>
      </button>
    </form>
  </div>
</template>

<script>
import BaseLockup from '@/components/BaseLockup/BaseLockup'
import BaseText6 from '@/components/BaseText6/BaseText6'
import BaseInput from '@/components/BaseInput/BaseInput'
import BaseButtonOctagon from '@/components/BaseButtonOctagon/BaseButtonOctagon'
import UserService from '@/services/UserService'
import { mapState } from 'vuex'
export default {
  name: 'form',
  components: {
    BaseLockup,
    BaseText6,
    BaseInput,
    BaseButtonOctagon
  },
  data () {
    return {
      email: '',
      errorMessage: null
    }
  },
  computed: mapState('user', [
    'userProfile'
  ]),
  methods: {
    async submit () {
      try {
        const user = await UserService.updateUserEmail(this.userProfile._id, this.email)
        this.$store.commit('user/setUserProfile', user)
        this.$router.push('/')
      } catch (error) {
        this.errorMessage = 'Error updating email.'
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.form {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  flex-direction: column;
  text-align: center;
}
.lockup {
  width: 8.5rem !important;
}
form {
  height: 100%;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
}
.subcopy {
  margin-bottom: 4rem;
}
.input-container {
  width: 100%;
  margin-bottom: 4rem;
}
.error-message {
  margin-top: 1rem;
  text-align: left;
  color: var(--color-red-1);
}
</style>
